module.exports = __webpack_public_path__ + "static/media/social-responsibility.44969cdc.png";